export default {
  'en-US': {
    attachments: {
      Other: 'Other Attachment',
      VendorManual: 'Vendor Manual Upload',
      PO: 'P.O. Upload'
    }
  },
  'ja-JP': {
    attachments: {
      Other: 'その他の添付ファイル',
      VendorManual: 'ベンダーマニュアルのアップロード',
      PO: 'P.O.アップロード'
    }
  }
}
